export const DEFAULT_EXPECTED_TO = 'listmanager';

export const DEFAULT_ALLOW_FROM = ['rocket'];

export const DEFAULT_VALID_ORIGIN_RES = [
  /^https:\/\/localhost:3000$/,
  /^https:\/\/contact-[a-z]{2,3}\.greens\.org\.au$/,
  /^https:\/\/contact-[a-z]{2,3}\.(dev|prod)\.greens\.systems$/,
  /^https:\/\/contact-federalmps\.greens\.org\.au$/,
  /^https:\/\/contact-federalmps\.(dev|prod)\.greens\.systems$/
];

export const DEFAULT_REQUEST_RESPONSE_TIMEOUT_MS = 15 * 1000;
